module.exports = __webpack_public_path__ + "img/portugal.88e996b.webp";